import queryString from 'query-string'

const shortenUrlEndPoint = '/api/shortlink-creator'

export default async function shortenUrl(url) {
  try {
    const fetchUrl = `${shortenUrlEndPoint}?${queryString.stringify({ longLink: url })}`
    const response = await fetchFromApi(fetchUrl)
    return response
  } catch (error) {
    return { error }
  }
}

async function fetchFromApi(url) {
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({})
  })
  if (response.status !== 200) throw new Error(`Failed with status ${response.status}`)
  return await response.json()
}



// WEBPACK FOOTER //
// ./src/apis/short-url.js